import React, { useEffect, useState } from "react";
import Select from "./Select";
import OptionValueApi from "../../services/OptionValueApi";

type Props = any;

const SelectCNHType: React.FC<Props> = ({ name, control, multiple, style, label}) => {
  const [cnhTypeList, setCnhTypeList] = useState<any>([]);

  useEffect(() => {
    OptionValueApi.search('AETipoCNH').then(response => {
      if (response) {
          setCnhTypeList(response.map(
              (status: any) => ({ code: status.code, label: status.description })));
      }
    })
  }, []);

  return (
    <Select 
      label={label} 
      name={name}
      control={control} 
      options={cnhTypeList}
      multiline={multiple}
      style={style ? style : {width: '100%'}}/>
  )
}

export default SelectCNHType;
